import Promise from 'promise-polyfill';

// Polyfill needed for webpack System support
if (!window.Promise) {
    window.Promise = Promise;
}


import _ from 'underscore';
import Chart from 'chart.js';

import angular from 'angular';

import uiRouter from 'angular-ui-router';
import ngSanitize from 'angular-sanitize';
import ngCookies from 'angular-cookies';
import ngMessages from 'angular-messages';
import ngTouch from 'angular-touch';
import ngJwt from 'angular-jwt';
import ngLoadingBar from 'angular-loading-bar';
import ngAnimate from 'angular-animate';
import ngDialog from 'ng-dialog';
import uiSelect from 'ui-select';
import ngTooltips from 'angular-tooltips';
import 'angular-ladda-lw/dist/angular-ladda-lw';
import ngTranslate from 'angular-translate';

import 'fullcalendar';
import 'angular-ui-calendar';

import 'angular-datepicker-polyfill/dist/angular-date-picker-polyfill';
import 'flatpickr/dist/flatpickr';
import flatPickrTranslationModule from './flatpickrTranslation';

import 'ngSmoothScroll/lib/angular-smooth-scroll';
import ngInfiniteScroll from 'ng-infinite-scroll';
import ngLogglyLogger from 'angular-loggly-logger';
import ngGoogleAnalytics from 'angular-google-analytics';
import ngSmartTable from 'angular-smart-table';

import 'angular-moment';

import Flow from '@flowjs/flow.js';
import '@flowjs/ng-flow/dist/ng-flow';
import 'sortablejs';
import 'angular-legacy-sortablejs-maintained';

import configModule from './config';
import translationModule from './translation';

import '../style/app.scss';

angular.module('am4', [
    configModule.name,
    translationModule.name,
    flatPickrTranslationModule.name,
    uiRouter,
    ngSanitize,
    ngCookies,
    ngMessages,
    ngTouch,
    ngJwt,
    ngLoadingBar,
    ngAnimate,
    ngDialog,
    uiSelect,
    ngTooltips,
    'angular-ladda-lw',
    ngTranslate,
    'ui.calendar',
    'angular-date-picker-polyfill',
    'smoothScroll',
    'angularMoment',
    ngInfiniteScroll,
    ngLogglyLogger,
    ngGoogleAnalytics,
    ngSmartTable,
    'flow',
    'ng-sortable'
])
.constant('moment', require('moment-timezone'))
.constant('STRINGS', {
    APPLICATION_NAME: 'Asset Management 4'
})
.constant('REGEX', {
    REGEX_CHARACTERS: /[-\/\\^$*+?.()|[\]{}]/g,
    SPACES: /\s+/
})
.constant('CONVERSIONS', {
    MILES_100_PER_MILE: 100,
    KM_PER_MILE: 1.60934,
    STEPS_PER_FLOOR: 16,
    KG_CONSTANT: 2.20462
});

angular.module('am4').config(function($httpProvider, configProvider, $locationProvider, $stateProvider, $urlRouterProvider, $touchProvider, $compileProvider, ngDialogProvider, uiSelectConfig, LogglyLoggerProvider, AnalyticsProvider, cfpLoadingBarProvider, flowFactoryProvider) {
    'ngInject';

    $stateProvider
    .state('nolang', {
        url: '^/',
        controller: 'langController'
    })
    .state('app', {
        url: '^/:lang',
        loggedInRedirectTo:'app.am4.dashboard.results',
        params: {
            lang: ''
        },
        controller: 'langController',
        template: '<ui-view></ui-view>'
    })
    .state('app.maintenance', {
        url: '/maintenance',
        template: require('./views/maintenance.html'),
        controllerAs: 'maintenanceCtrl',
        controller: function() {
            this.refresh = function() {
                // navigate to root to get user to helpful page if maintenance has ended
                window.location.replace(window.location.origin);
            };
        }
    })
    .state('app.login', {
        url: '/login?then',
        template: require('./views/login.html'),
        controller: 'loginController as loginCtrl',
        params: {
            email: null
        }
    })
    .state('app.expired', {
        url: '/session-expired',
        template: require('./views/expired.html'),
        params: {
            email: null
        },
        controllerAs: 'expired',
        controller: function($stateParams) {
            this.email = $stateParams.email;
        }
    })
    .state('app.forgot', {
        url: '/forgot',
        template: require('./views/forgot/layout.html')
    })
    .state('app.forgot.request', {
        abstract: true,
        url: '/request',
        template: '<ui-view></ui-view>'
    })
    .state('app.forgot.request.form', {
        url: '',
        template: require('./views/forgot/request/form.html'),
        controller: 'forgotRequestCtrl as forgotRequestCtrl',
        params: {
            email: null
        }
    })
    .state('app.forgot.request.sent', {
        template: require('./views/forgot/request/sent.html'),
        params: {
            email: null
        },
        controllerAs: 'sent',
        controller: function($stateParams) {
            this.email = $stateParams.email;
        }
    })
    .state('app.forgot.request.error', {
        template: require('./views/forgot/request/error.html'),
        params: {
            email: null
        },
        controller: function($stateParams) {
            this.email = $stateParams.email;
        },
        controllerAs: 'error'
    })
    .state('app.forgot.reset', {
        abstract: true,
        url: '/reset?token',
        template: '<ui-view></ui-view>'
    })
    .state('app.forgot.reset.form', {
        url: '',
        template: require('./views/forgot/reset/form.html'),
        controller: 'forgotResetCtrl as forgotResetCtrl'
    })
    .state('app.forgot.reset.expired', {
        template: require('./views/forgot/reset/expired.html'),
        params: {
            email: null
        },
        controller: function($stateParams) {
            this.email = $stateParams.email;
        },
        controllerAs: 'expired'
    })
    .state('app.forgot.reset.invalid', {
        template: require('./views/forgot/reset/invalid.html')
    })
    .state('app.forgot.reset.error', {
        template: require('./views/forgot/reset/error.html'),
        params: {
            email: null
        },
        controller: function($stateParams) {
            this.email = $stateParams.email;
        },
        controllerAs: 'error'
    })
    .state('app.forgot.reset.success', {
        template: require('./views/forgot/reset/success.html'),
        params: {
            email: null
        },
        controller: function($stateParams) {
            this.email = $stateParams.email;
        },
        controllerAs: 'success'
    })
    .state('app.am4', {
        abstract: true,
        template: require('./views/loggedInNavWrapper.html'),
        controller: 'loggedInNavCtrl',
        resolve: {
            authorizationToken: ['UserService', 'errorService', '$q', function(UserService, errorService, $q) {
                // Force user to resolve before allowing routing to this state
                // (stops potential for race conditions)
                if (UserService.token) {
                    return $q.resolve(UserService.token);
                }
                throw new errorService.AuthorizationError();

            }],
            userPermissions: ['UserService', '$rootScope', function(UserService, $rootScope) {
                return UserService.user.then(function(user) {
                    $rootScope.userPermissions = user.permissions;
                    return user.permissions;
                });
            }]
        }
    })
    .state('app.am4.profile', {
        url: '/profile',
        template: require('./views/profile.html'),
        controller: 'profileCtrl',
        controllerAs: 'profileCtrl',
        resolve: {
            subscriptions: ['UserService', 'subscriptionService', function(UserService, subscriptionService) {
                return UserService.user.then(function(user) {
                    return subscriptionService.getUserSubscriptions(user.user_id);
                }).then(function(subscriptions) {
                    return subscriptionService.formatWithNames(subscriptions);
                });
            }]
        }
    })
    .state('app.am4.home', {
        url: '/home',
        controller: function($state, UserService) {
            return UserService.user.then(function(user) {
                if (user.permissions.includes('EQUIPMENT_PAGE')) {
                    $state.go('app.am4.dashboard.results');
                } else if (user.user_metadata.am_facilities.length === 1) {
                    $state.go('app.am4.facility', { id: user.user_metadata.am_facilities[0] });
                } else {
                    $state.go('app.am4.facilities');
                }
            });
        }
    })
    .state('app.am4.dashboard', {
        abstract: true,
        url: '/dashboard?filterId',
        template: require('./views/dashboard/dashboard.html'),
        controller: 'dashboardCtrl as dash',
        params: {
            filter: null
        },
        resolve: {
            filter: ['$q', '$state', '$stateParams', 'filterService', 'errorService', function($q, $state, $stateParams, filterService, errorService) {
                if ($stateParams.filter) {

                    // probably just created one and already got the data
                    return $stateParams.filter;

                } else if ($stateParams.filterId) {

                    // try to look up the filter by id
                    return filterService.getFilterById($stateParams.filterId)
                    .catch(function(e) {
                        // go to the dashboard
                        return $state.go('app.am4.dashboard.results', {
                            filterId: null,
                            filter: null,
                            lang: $stateParams.lang
                        }).then(function() {
                            errorService.addError('LOAD_FILTER_ERROR', e);
                        });
                    });

                }

                    // the dashboard -- don't return a filter
                return $q.resolve(null);

            }]
        }
    })
    .state('app.am4.dashboard.results', {
        url: '',
        template: require('./views/dashboard/results.html'),
        permissions: ['EQUIPMENT_PAGE']
    })
    .state('app.am4.dashboard.report', {
        url: '/report',
        template: require('./views/dashboard/report.html'),
        controller: 'reportCtrl as reportCtrl'
    })
    .state('app.am4.organizations', {
        url: '/organizations',
        template: require('./views/orgFacList.html'),
        controller: 'orgFacListCtrl',
        resolve: {
            dictionary: ['orgFacService', function(orgFacService) {
                return orgFacService.getOrganizations();
            }]
        }
    })
    .state('app.am4.organizations.new', {
        url: '/new',
        onEnter: ['$state', '$stateParams', '$rootScope', 'ngDialog', function($state, $stateParams, $rootScope, ngDialog) {
            if ($rootScope.userPermissions.indexOf('JHT_ORG_FAC_MANAGEMENT') !== -1) {
                ngDialog.open({
                    template: require('./views/modal/newOrganization.html'),
                    plain: true,
                    scope: $rootScope.$new(),
                    controller: 'newOrganizationCtrl',
                    controllerAs: 'newOrganizationCtrl'
                }).closePromise.finally(function() {
                    $state.go('^');
                });
            }
        }],
        onExit: ['ngDialog', function(ngDialog) {
            ngDialog.closeAll();
        }],
        permissions: ['JHT_ORG_FAC_MANAGEMENT']
    })
    .state('app.am4.users', {
        url: '/users',
        template: require('./views/users.html'),
        controller: 'usersCtrl as usersCtrl',
        permissions: ['JHT_USER_MANAGEMENT']
    })
    .state('app.am4.createuser', {
        url: '/users/create',
        template: require('./views/user/createUser.html'),
        controller: 'createUserCtrl as createUserCtrl',
        permissions: ['JHT_USER_MANAGEMENT']
    })
    .state('app.am4.user', {
        url: '/users/:id',
        redirectTo:'app.am4.user.details',
        template: require('./views/user/user.html'),
        controller: 'userCtrl as userCtrl',
        resolve: {
            userData: ['users', '$stateParams', '$rootScope', function(users, $stateParams, $rootScope) {
                $rootScope.spinning = true;

                return users($stateParams.id)
                .get()
                .finally(function() {
                    $rootScope.spinning = false;
                });
            }]
        },
        permissions: ['JHT_USER_MANAGEMENT']
    })
    .state('app.am4.user.details', {
        template: require('./views/user/details.html'),
        permissions: ['JHT_USER_MANAGEMENT']
    })
    .state('app.am4.user.subscriptions', {
        url: '/subscriptions',
        template: require('./views/user/subscriptions.html'),
        permissions: ['JHT_USER_MANAGEMENT']
    })
    .state('app.am4.user.tags', {
        url: '/tags',
        template: require('./views/user/tags.html'),
        permissions: ['JHT_USER_MANAGEMENT']
    })
    .state('app.am4.organization', {
        redirectTo:'app.am4.organization.facilities',
        url: '/organization/:id',
        template: require('./views/organization/organization.html'),
        permissions: ['ORG_READ'],
        controller: 'orgCtrl as org',
        resolve: {
            subscriptions: ['$stateParams', 'UserService', 'subscriptionService', function($stateParams, UserService, subscriptionService) {
                return UserService.user
                .then(function(user) {
                    return subscriptionService.getUserSubscriptions(user.user_id);
                });
            }],
            organizationData: ['$stateParams', 'orgFacService', function($stateParams, orgFacService) {
                return orgFacService.getOrganization($stateParams.id);
            }],
            user: ['UserService', function(UserService) {
                return UserService.user.then(function(user) {
                    return user;
                });
            }],
            organizationContact: ['$stateParams', 'contactService', function($stateParams, contactService) {
                return contactService.getOrganizationContact($stateParams.id);
            }]
        }
    })
    .state('app.am4.organization.facilities', {
        url: '/facilities',
        template: require('./views/organization/facilities.html'),
        permissions: ['ORG_READ']
    })
    .state('app.am4.organization.facilities.new', newFacilityDefinition(true)) // use organization ID
    .state('app.am4.organization.tasks', {
        url: '/tasks',
        template: require('./views/organization/tasks.html'),
        permissions: ['ORG_READ']
    })
    .state('app.am4.organization.tasks.logo', {
        url: '/logo',
        params: {
            imageType: 'logo',
            type: 'organizations'
        },
        permissions: ['ORG_READ'],
        template: require('./views/imageEdit.html'),
        controller: 'imageEditCtrl as imageEditCtrl'
    })
    .state('app.am4.organization.tasks.splash', {
        url: '/splash',
        params: {
            imageType: 'splash',
            type: 'organizations'
        },
        permissions: ['ORG_READ'],
        template: require('./views/welcomeScreen.html'),
        controller: 'welcomeScreenCtrl as welcomeScreenCtrl'
    })
    .state('app.am4.facilities', {
        url: '/facilities',
        template: require('./views/orgFacList.html'),
        controller: 'orgFacListCtrl',
        resolve: {
            dictionary: ['orgFacService', function(orgFacService) {
                return orgFacService.getFacilities();
            }]
        },
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facilities.new', newFacilityDefinition())
    .state('app.am4.facility', {
        url: '/facility/:id',
        template: require('./views/facility/facility.html'),
        controller: 'facCtrl as fac',
        resolve: {
            facilityData: ['$stateParams', 'orgFacService', function($stateParams, orgFacService) {
                return orgFacService.getFacility($stateParams.id);
            }],
            subscriptions: ['$stateParams', 'UserService', 'subscriptionService', function($stateParams, UserService, subscriptionService) {
                return UserService.user
                .then(function(user) {
                    return subscriptionService.getUserSubscriptions(user.user_id);
                });
            }],
            user: ['UserService', function(UserService) {
                return UserService.user.then(function(user) {
                    return user;
                });
            }],
            facilityContact: ['$stateParams', 'contactService', function($stateParams, contactService) {
                return contactService.getFacilityContact($stateParams.id);
            }]
        },
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.errorcodes', {
        url: '/events',
        template: require('./views/facility/errorcodes.html'),
        permissions: ['FACILITY_READ', 'EQUIPMENT_PAGE']
    })
    .state('app.am4.facility.nce', {
        url: '/non-connected-equipment',
        template: require('./views/facility/nce.html'),
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.groups', {
        url: '/groups',
        template: require('./views/facility/groups.html'),
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.calendar', {
        url: '/calendar',
        template: require('./views/facility/calendar.html'),
        controller: 'calendarCtrl as calendarCtrl',
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.servicerequests', {
        url: '/servicerequests',
        template: require('./views/facility/servicerequests.html'),
        permissions: ['FACILITY_READ', 'CONNECTED_SERVICE_REQUEST']
    })
    .state('app.am4.facility.tasks', {
        url: '/tasks',
        template: require('./views/facility/tasks.html'),
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.ecofit', {
        url: '/ecofit',
        template: require('./views/facility/ecofit.html'),
        permissions: ['ECOFIT']
    })
    .state('app.am4.facility.tasks.logo', {
        url: '/logo',
        params: {
            imageType: 'logo',
            type: 'facilities'
        },
        template: require('./views/imageEdit.html'),
        controller: 'imageEditCtrl as imageEditCtrl',
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.tasks.splash', {
        url: '/splash',
        params: {
            imageType: 'splash',
            type: 'facilities'
        },
        template: require('./views/welcomeScreen.html'),
        controller: 'welcomeScreenCtrl as welcomeScreenCtrl',
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.tasks.maps', {
        url: '/maps',
        template: require('./views/facility/maps.html'),
        controller: 'mapsCtrl as mapsCtrl',
        permissions: ['FACILITY_READ', 'FACILITY_MAPS']
    })
    .state('app.am4.facility.tasks.messages', {
        url: '/messages?group',
        template: require('./views/facility/messages.html'),
        controller: 'facilityMessagesCtrl as facilityMessagesCtrl',
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.tasks.maps.view', {
        url: '/{mapId:[0-9]+}',
        params: {
            map: null
        },
        resolve: {
            map: ['$stateParams', 'mapsService', function($stateParams, mapsService) {
                if ($stateParams.map !== null) {
                    return $stateParams.map;
                }
                return mapsService.get($stateParams.mapId, $stateParams.id);

            }]
        },
        onEnter: ['$state', '$stateParams', '$rootScope', 'ngDialog', 'map', function($state, $stateParams, $rootScope, ngDialog, map) {
            ngDialog.open({
                template: require('./views/modal/map.html'),
                plain: true,
                className: 'ngdialog-theme-plain--wide',
                scope: $rootScope.$new(),
                controller: 'mapCtrl',
                controllerAs: 'mapCtrl',
                resolve: {
                    map: function() {
                        return map;
                    }
                }
            }).closePromise.finally(function() {
                $state.go('^');
            });
        }],
        onExit: ['ngDialog', function(ngDialog) {
            ngDialog.closeAll();
        }],
        permissions: ['FACILITY_READ']
    })
    .state('app.am4.facility.tasks.maps.new', {
        url: '/new',
        onEnter: ['$state', '$stateParams', '$rootScope', 'ngDialog', function($state, $stateParams, $rootScope, ngDialog) {
            ngDialog.open({
                template: require('./views/modal/newMap.html'),
                plain: true,
                scope: $rootScope.$new(),
                controller: 'newMapCtrl',
                controllerAs: 'newMapCtrl'
            }).closePromise.finally(function() {
                $state.go('^');
            });
        }],
        onExit: ['ngDialog', function(ngDialog) {
            ngDialog.closeAll();
        }],
        permissions: ['FACILITY_TASKS']
    })
    .state('app.am4.facility.tasks.messages.edit', {
        url: '/:messageId',
        onEnter: ['$state', '$stateParams', '$rootScope', 'ngDialog', 'message', 'timezone', 'equipmentGroups',
            function($state, $stateParams, $rootScope, ngDialog, message, timezone, equipmentGroups) {
                ngDialog.open({
                    template: require('./views/modal/message.html'),
                    plain: true,
                    scope: $rootScope.$new(),
                    controller: 'messageCtrl',
                    controllerAs: 'messageCtrl',
                    resolve: {
                        message: () => message,
                        timezone: () => timezone,
                        equipmentGroups: () => equipmentGroups
                    }
                }).closePromise.finally(function() {
                    $state.go('^');
                });
            }
        ],
        onExit: ['ngDialog', function(ngDialog) {
            ngDialog.closeAll();
        }],
        params: {
            message: null
        },
        resolve: {
            timezone: ['facilityData', function(facilityData) {
                return facilityData.time_zone;
            }],
            message: ['$stateParams', 'messagesService', function($stateParams, messagesService) {
                if ($stateParams.messageId !== 'new') {
                    if ($stateParams.message !== null) {
                        return angular.copy($stateParams.message);
                    }

                    var facilityMessages = messagesService.facility($stateParams.id);

                    if ($stateParams.group) {
                        facilityMessages = facilityMessages.group($stateParams.group);
                    }

                    return facilityMessages.get($stateParams.messageId);
                }

                return null;
            }],
            equipmentGroups: ['$stateParams', 'equipmentGroupService', function($stateParams, equipmentGroupService) {
                return equipmentGroupService.getEquipmentGroups($stateParams.id);
            }]
        },
        permissions: ['FACILITY_TASKS']
    })
    .state('app.am4.facility.calendar.event', {
        url: '/event/:event_id',
        params: {
            event_id: null
        },
        resolve: {
            timezone: ['facilityData', function(facilityData) {
                return facilityData.time_zone;
            }],
            event: ['$stateParams', 'calendarService', function($stateParams, calendarService) {
                if ($stateParams.event_id === null) {
                    return {};
                }
                return calendarService.getEventById($stateParams.event_id, $stateParams.id);

            }]
        },
        onEnter: ['$state', '$stateParams', '$rootScope', 'ngDialog', 'event', 'timezone', function($state, $stateParams, $rootScope, ngDialog, event, timezone) {
            ngDialog.open({
                template: require('./views/modal/calendarEvent.html'),
                plain: true,
                scope: $rootScope.$new(),
                controller: 'calendarEventCtrl',
                controllerAs: 'calendarEventCtrl',
                resolve: {
                    event: () => event,
                    timezone: () => timezone
                }
            }).closePromise.finally(function() {
                $state.go('^');
            });
        }],
        onExit: ['ngDialog', function(ngDialog) {
            ngDialog.closeAll();
        }],
        permissions: ['FACILITY_READ', 'FACILITY_CALENDAR']
    })
    .state('app.am4.facility.nce.nonconnectedMachine', {
        url: '/:equipment_id',
        params: {
            equipment_id: null
        },
        resolve: {
            equipment: ['$stateParams', 'nonconnectedMachineService', function($stateParams, nonconnectedMachineService) {
                if ($stateParams.equipment_id === null) {
                    return {};
                }
                return nonconnectedMachineService.getNonconnectedMachineById($stateParams.equipment_id);

            }],
            organization_id: ['$stateParams', 'orgFacService', function($stateParams, orgFacService) {
                return orgFacService.getFacility($stateParams.id)
                .then(function(res) {
                    return res.organization_id;
                });
            }]
        },
        onEnter: ['$state', '$rootScope', 'ngDialog', 'equipment', 'organization_id', function($state, $rootScope, ngDialog, equipment, organization_id) {
            ngDialog.open({
                template: require('./views/modal/upsertNCEquipment.html'),
                plain: true,
                scope: $rootScope.$new(),
                controller: 'upsertNCEquipmentCtrl as nce',
                className: 'ngdialog-theme-plain--wide',
                resolve: {
                    equipment: function() {
                        return equipment;
                    },
                    organization_id: function() {
                        return organization_id;
                    }
                }
            }).closePromise.finally(function() {
                $state.go('^');
            });
        }],
        onExit: ['ngDialog', function(ngDialog) {
            ngDialog.closeAll();
        }],
        permissions: ['FACILITY_READ', 'FACILITY_NONCONNECTED_EQUIPMENT']
    })
    .state('app.am4.equipment', {
        url: '/equipment/:id',
        template: require('./views/equipment/equipment.html'),
        controller: 'machineCtrl as machineCtrl',
        permissions: ['EQUIPMENT_PAGE'],
        resolve: {
            machineData: ['$stateParams', 'machineService', function($stateParams, machineService) {
                return machineService.getMachineDetail($stateParams.id)
                .then(function(res) {
                    return res.data;
                });
            }]
        }
    })
    .state('app.am4.equipment.documents', {
        url: '/documents',
        permissions: ['EQUIPMENT_PAGE'],
        template: require('./views/equipment/documents.html')
    })
    .state('app.am4.equipment.stats', {
        url: '/stats',
        permissions: ['EQUIPMENT_PAGE'],
        template: require('./views/equipment/stats.html')
    })
    .state('app.am4.equipment.snapshots', {
        url: '/snapshots',
        permissions: ['EQUIPMENT_SUPPORT'],
        template: require('./views/equipment/snapshots.html'),
        controller: 'equipmentSnapshotsCtrl as equipmentSnapshotsCtrl'
    })
    .state('app.am4.equipment.history', {
        url: '/history',
        permissions: ['EQUIPMENT_PAGE'],
        template: require('./views/equipment/history.html'),
        controller: 'equipmentWorkoutsCtrl as equipmentWorkoutsCtrl'
    })
    .state('app.am4.equipment.software', {
        url: '/software',
        permissions: ['EQUIPMENT_PAGE'],
        template: require('./views/equipment/software.html')
    })
    .state('app.am4.equipment.errorcodes', {
        url: '/events',
        permissions: ['EQUIPMENT_PAGE'],
        template: require('./views/equipment/errorcodes.html'),
        controller: 'equipmentErrorCodesCtrl as equipmentErrorCodesCtrl'
    })
    .state('app.am4.equipment.servicerequests', {
        url: '/servicerequests',
        permissions: ['EQUIPMENT_PAGE', 'CONNECTED_SERVICE_REQUEST'],
        template: require('./views/equipment/servicerequests.html')
    })
    .state('app.500', {
        template: require('./views/500.html'),
        controllerAs: 'error500Ctrl',
        controller: function() {
            this.refresh = function() {
                window.location.reload();
            };
        }
    })
    .state('app.404', {
        url: '*path',
        template: require('./views/404.html'),
        controller: function($scope, langRegex, $stateParams, $location, $translate) {
            if (langRegex.test($stateParams.lang)) {
                // prevent flashing view if 'else'
                $scope.valid404 = true;
            } else {
                $location
                .path('/' + $translate.preferredLanguage() + window.location.pathname)
                .replace();
            }
        }
    })
    .state('app.am4.403', {
        url: '*path',
        template: require('./views/403.html'),
        controller: function($scope, langRegex, $stateParams, $location, $translate) {
            if (langRegex.test($stateParams.lang)) {
                // prevent flashing view if 'else'
                $scope.valid403 = true;
            } else {
                $location
                .path('/' + $translate.preferredLanguage() + window.location.pathname)
                .replace();
            }
        }
    });

    $touchProvider.ngClickOverrideEnabled(true);

    // Redirect unknown routes to root
    $urlRouterProvider
    .when('', '/home')
    .when('/', '/home');

    $locationProvider.html5Mode(true);

    ngDialogProvider.setDefaults({
        className: 'ngdialog-theme-plain'
    });

    uiSelectConfig.theme = 'select2';

    var config = configProvider.config;

    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);

    if (config.env !== 'local') {
        $compileProvider.debugInfoEnabled(false);
    }

    // Only run in deployed environment
    if (config.logglyKey && config.env !== 'local') {
        LogglyLoggerProvider
        .inputToken(config.logglyKey)
        .sendConsoleErrors(true)
        .includeUrl(true)
        .deleteHeaders(true)
        .inputTag('angular,am4-' + config.env);
    }

    if (config.googleAnalytics) {
        AnalyticsProvider.setAccount(config.googleAnalytics);
    } else {
        // else no analytics
        AnalyticsProvider.startOffline(true);
    }

    // We're using ui-router instead of ngRouter
    AnalyticsProvider.trackPages(true);
    AnalyticsProvider.setPageEvent('$stateChangeSuccess');

    Chart.defaults.global.elements.point.hitRadius = 15;

    Chart.defaults.global.legend.labels.boxWidth = 20;
    Chart.defaults.global.legend.labels.padding = 25;

    // Configure our loading bar & spinner
    cfpLoadingBarProvider.includeSpinner = false;

    // Configure flow.js uploader
    flowFactoryProvider.factory = function(opts) {
        return new Flow(opts);
    };
    flowFactoryProvider.defaults = {
        testChunks: false,
        chunkSize: 10485760,
        fileParameterName: 'image'
    };

    $httpProvider.interceptors.push('maintenanceModeInterceptor');
});

function newFacilityDefinition(useOrgId) {
    return {
        url: '/new',
        resolve: {
            countries: ['geoService', function(geoService) {
                return geoService.getCountries();
            }],
            availableOrganizations: ['orgFacService', function(orgFacService) {
                return orgFacService.getOrganizationsDictionary()
                .then(function(availableOrganizations) {
                    return availableOrganizations;
                });
            }]
        },
        onEnter: ['$state', '$stateParams', 'countries', 'availableOrganizations', 'ngDialog', '$rootScope',
            function($state, $stateParams, countries, availableOrganizations, ngDialog, $rootScope) {
                if ($rootScope.userPermissions.indexOf('JHT_ORG_FAC_MANAGEMENT') !== -1) {
                    ngDialog.open({
                        template: require('./views/modal/createFacility.html'),
                        plain: true,
                        controller: 'newFacilityCtrl',
                        controllerAs: 'facilityCtrl',
                        resolve: {
                            countries: function() {
                                return countries;
                            },
                            availableOrganizations: function() {
                                return availableOrganizations;
                            },
                            orgId: function() {
                                return useOrgId ? $stateParams.id : null;
                            }
                        }
                    }).closePromise.finally(function() {
                        $state.go('^');
                    });
                }
            }
        ],
        onExit: ['ngDialog', function(ngDialog) {
            ngDialog.closeAll();
        }],
        permissions: ['JHT_ORG_FAC_MANAGEMENT']
    };
}


angular.module('am4').run(function($rootScope, UserService, $urlRouter, $state, config, $stateParams, $translate, $location, langRegex, $timeout, errorService) {
    'ngInject';

    $rootScope.config = config;

    $rootScope.$on('$stateChangeSuccess', function(event, toState) {
        if (toState.permissions) {
            let statePermissions = [].concat(toState.permissions);
            if (_.intersection(statePermissions, $rootScope.userPermissions).length < statePermissions.length) {
                $state.go('app.am4.403', {}, {
                    location: false
                });
                event.preventDefault();
            }
        }
    });

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
        // Negotiate language from the parameter language
        // if lang is something like en-US it will resolve to en
        var newLang = $translate.negotiateLocale(toParams.lang),
            nextParams = toParams;

        UserService.user.then(function(userData) {
            toState.redirectTo = toState.loggedInRedirectTo;

            // True if:
            // - the state has a supported language
            //   AND
            // - the logged in user's preferred language is different from the state's language
            //   AND
            // - the negotiated language is the same as the parameter language
            if (toParams.lang && toParams.lang === newLang &&
                userData && userData.language && userData.language !== newLang
            ) {
                nextParams.lang = userData.language;
                $state.go(toState, nextParams, {
                    reload: true,
                    // don't break back button, since we're automatically forwarding user location:
                    location: 'replace'
                });
                event.preventDefault();
                return;
            }
        });

        // We're trying to go to a language that doesn't exist
        // Redirect to the correct language from $translate
        if ((langRegex.test(toParams.lang) && newLang !== toParams.lang) || toParams.lang === newLang + '/') {
            if (angular.isUndefined($translate.negotiateLocale($translate.preferredLanguage()))) {
                $translate.preferredLanguage($translate.fallbackLanguage());
            }
            toParams.lang = angular.isUndefined(newLang)? $translate.preferredLanguage() : newLang;

            event.preventDefault();
            $state.go(toState, toParams, { location: 'replace' });
            return;
        }

        // At this point toParams.lang and newLang (the negotiated language) should be the same

        if (!_.contains(['app.login', 'nolang', 'app'], toState.name)) {
            UserService.user.then(function(user) {
                $rootScope.logged_in_user = user;
            }, function() {
                $rootScope.logged_in_user = false;
            });
        }

        // Set language from lang in path
        if (langRegex.test(toParams.lang)) {
            $translate.preferredLanguage(toParams.lang);
            $rootScope.lang = toParams.lang;
        } else if (angular.isUndefined($translate.negotiateLocale($translate.preferredLanguage()))) {
            $translate.preferredLanguage($translate.fallbackLanguage());
        }
        $translate.use($translate.preferredLanguage());

        if (toState.redirectTo) {
            event.preventDefault();
            $state.go(toState.redirectTo, toParams, { location: 'replace' });
        }
    });

    $rootScope.$on('$stateChangeSuccess', function() {
        errorService.deleteAllErrors();

        var newLang = $translate.negotiateLocale($stateParams.lang);

        if (!newLang) {
            if ($location.path() === '/') {
                $location
                .path('/' + $translate.preferredLanguage() + '/home')
                .replace(); // don't break the back button
            } else {
                // url: /sdlkfjsd
                $state.go('app.404', {}, {
                    location: false
                });
            }
            return;
        }

        // We're trying to go to just a language path
        if ($location.path() === '/' + newLang) {
            $location
            .path('/' + newLang + '/home')
            .replace(); // don't break the back button
            return;
        }
    });

    $rootScope.$on('$stateChangeError', function(e, toS, toP, fromS, fromP, error) {
        console.log(error); // eslint-disable-line no-console

        if (error instanceof errorService.AuthorizationError) {
            var loc = $location.path();

            // TODO this needs to be refactored to not use timeout
            // We use it to let the current url finish routing before
            // trying to override it
            $timeout(function() {
                // Send to login page with :lang set
                $location
                .path('/' + $translate.preferredLanguage() + '/login')
                .search({
                    then: loc
                })
                .replace();
            });
        } else {
            // Some unknown/generic/not caught error
            // Ideally, in all route 'resolve's, we would do
            // .catch(function() {
            //   throw new errorService.aMoreSpecificError();
            // })
            // and then we would handle it above ^ like:
            // if (error instanceof errorService.aMoreSpecificError)

            e.preventDefault();

            $state.go('app.500', {
                lang: toP.lang
            }, {
                location: false
            });

        }
    });

    $rootScope.$watch(function() {
        return UserService.user;
    }, function() {
        $rootScope.logged_in_user = false;
    });
});

/* eslint-disable no-unused-vars */

// Need to inject at least once to setup
angular.module('am4').run(function(Analytics) {
    'ngInject';
});

/* eslint-enable no-unused-vars */

angular.module('am4').run(function($rootScope, $timeout, config) {
    'ngInject';

    // show initial large centered loading spinner while app initializes
    $rootScope.spinning = true;
    var appInitialized = $rootScope.$on('$stateChangeSuccess', function() {
        $rootScope.spinning = false;
        appInitialized(); // de-register the listener
    });

    $rootScope
    .$on('$stateChangeStart',
            function() {
                $rootScope.$broadcast('cfpLoadingBar:started', { isStateChange: true });
            });

    $rootScope
    .$on('$stateChangeSuccess',
            function() {
                if (!$rootScope.isLoadingXhr) {
                    $rootScope.$broadcast('cfpLoadingBar:completed');
                } // else we are still waiting on xhr activity to complete
            });

    $rootScope.slowLoad = false;

    $rootScope
    .$on('cfpLoadingBar:started',
            function(event, options) {
                if (options && options.isStateChange) {
                    $rootScope.isLoadingXhr = false;
                } else {
                    $rootScope.isLoadingXhr = true;
                }
                if (!$rootScope.hasOwnProperty('xhrLoadTimer')) {
                    $rootScope.xhrLoadTimer = $timeout(function() {
                        $rootScope.slowLoad = true;
                    }, config.slowLoadTime);
                }
            });

    $rootScope
    .$on('cfpLoadingBar:completed',
            function() {
                $rootScope.isLoadingXhr = false;
                $timeout(function() {
                    // If new xrh activity gets underway within 1 second
                    // dont cancel the timeout, in order to give the appearance
                    // of a single loading activity to the end user
                    if (!$rootScope.isLoadingXhr) {
                        $timeout.cancel($rootScope.xhrLoadTimer);
                        delete $rootScope.xhrLoadTimer;
                        $rootScope.slowLoad = false;
                    }
                }, 1000);
            });

});


requireAll(require.context('./controllers', true, /\.js$/));
requireAll(require.context('./directives', true, /\.js$/));
requireAll(require.context('./filters', true, /\.js$/));
requireAll(require.context('./services', true, /\.js$/));

function requireAll(require) {
    require.keys().forEach(require);
}



// WEBPACK FOOTER //
// ./src/app/app.js